import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-computerproblem',
  templateUrl: './page-computerproblem.component.html',
  styleUrls: ['./page-computerproblem.component.css']
})
export class PageComputerproblemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
